var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBayrakk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 37,
    viewBox: "0 0 20 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79598 0C1.45252 0 1.12313 0.136437 0.880274 0.379297C0.637414 0.622156 0.500977 0.951545 0.500977 1.295V34.41L1.87005 36.63C1.87005 36.815 3.09098 34.41 3.09098 34.41V17.39H19.001C19.3444 17.39 19.6738 17.2536 19.9167 17.0107C20.1595 16.7678 20.296 16.4385 20.296 16.095V1.295C20.296 0.951545 20.1595 0.622156 19.9167 0.379297C19.6738 0.136437 19.3444 0 19.001 0H1.98098C1.94962 0.000237378 1.91827 0.00147133 1.887 0.0037C1.8567 0.00153301 1.82635 0.000299094 1.79598 0ZM6.90198 2.59H10.528V5.3391H14.154V2.59H17.706V5.3391H14.154V8.96473H17.706V12.5907H14.154V14.8H10.528V12.5911H6.90198V14.8H3.27598V12.5911H6.90198V8.96473H3.27598V5.33873H6.90198V2.59ZM6.90198 5.3391V8.96473H10.528V5.33873L6.90198 5.3391ZM10.528 8.96473V12.5911L14.154 12.5907V8.96473H10.528Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBayrakk);
export default __webpack_public_path__ + "static/media/bayrakk.b36479669abd1d983da0e79eb305c2c3.svg";
export { ForwardRef as ReactComponent };